module.exports = __webpack_public_path__ + "img/Feature.28a9ac76.jpg";